"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));
var _APLabelWithText = _interopRequireDefault(require("../../common/APLabelWithText"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _decimalPlacesHelper = require("../../../helpers/decimalPlaces/decimalPlacesHelper");
require("../../ConfirmOrderModal/ConfirmOrderModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('confirm-order-modal');
var ConfirmOrderModalComponent = function ConfirmOrderModalComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var formData = props.formData,
    isConfirmModalOpen = props.isConfirmModalOpen,
    dismissConfirmModal = props.dismissConfirmModal,
    confirmReport = props.confirmReport,
    metaData = props.metaData,
    orderFee = props.orderFee,
    resetForm = props.resetForm,
    priceIncrement = props.priceIncrement,
    quantityIncrement = props.quantityIncrement,
    clearForm = props.clearForm,
    setInstrument = props.setInstrument,
    selectedInstrumentId = props.selectedInstrumentId;
  var handleSubmit = function handleSubmit() {
    setInstrument({
      selectedInstrumentId: selectedInstrumentId,
      instrumentId: formData.selectedInstrumentId
    });
    clearForm();
    formData.fee = orderFee;
    if (formData.orderType == 'Limit Order') {
      formData.limitPrice = metaData.minmaxLimitValue;
    }
    confirmReport(formData);
    resetForm();
  };
  var items = [{
    label: t('Order Type'),
    text: formData.orderType
  }, {
    label: t('Quantity'),
    text: (0, _numberFormatter.formatNumberToLocale)(formData.quantity, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(quantityIncrement)) + " ".concat(metaData.Product1Symbol)
  }, {
    label: t('Price'),
    text: (0, _numberFormatter.formatNumberToLocale)(metaData.marketPrice, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(priceIncrement)) + " ".concat(metaData.Product2Symbol)
  }, {
    label: t('Fee'),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(orderFee.OrderFee, orderFee.product), " ").concat(orderFee.product)
  }, {
    label: t('Value'),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(formData.quantity * metaData.marketPrice, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(priceIncrement)), " ").concat(metaData.Product2Symbol)
  }];
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isConfirmModalOpen,
    title: t('Confirm Order'),
    close: dismissConfirmModal,
    footer: {
      buttonText: metaData.isBuySide ? t('Confirm Buy Order') : t('Confirm Sell Order'),
      buttonStyle: metaData.isBuySide ? 'additive' : 'subtractive',
      onClick: function onClick() {
        return handleSubmit();
      }
    },
    customClass: bemClasses(metaData.isBuySide ? 'bought' : 'sold')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses()
  }, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
      key: item.label,
      label: item.label,
      text: item.text,
      customClass: bemClasses()
    });
  })));
};
var _default = exports["default"] = ConfirmOrderModalComponent;